import * as React from 'react';
import { Component } from 'react';
import { AppBar, Tabs, Box } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import { withStyles } from '@material-ui/core/styles';
import { TabPanel, LinkTab, linkTabProps } from '../../../../components/ui/tabs';
import { EditMatchResultPlayersSelect } from "../../../../components/matches/EditMatchResultPlayersSelect";
import { EditMatchResultMiscSettings } from "../../../../components/matches/EditMatchResultMiscSettings";
import { AddReservePlayers } from "../../../../components/matches/AddReservePlayers";
import EditMatchResultBasicData from "../../../../components/matches/EditMatchResultBasicData";
import { leagueTeamActions } from "./actionsReducers";
import { Can, AbilitySubjects, userIsMemberOfClub } from '../../../../common/users';
import { parseQueryString, LeagueMatchAggregateViewModel, LeagueIndividualMatchViewModel, LeagueMatchReportingType } from '../../../../api';
import { ConnectedComponent } from "../../../../components/ConnectedComponent";
import { EditMatchResultActionLinks } from '../../../../components/matches/EditMatchResultActionLinks';
import { ErrorHandler } from '../../../../components/ErrorHandler';
import { Loader } from '../../../../common/loader';
const mapStateToProps = (state) => {
    return {
        model: state.leagueTeams.match,
        user: state.users.loggedInUser.user,
        isLoading: state.leagueTeams.isLoading,
        errors: state.leagueTeams.errors,
        systemErrors: state.errors.errors,
        texts: state.leagueTeams.match && state.leagueTeams.match.texts
    };
};
const mapDispatchToProps = (dispatch) => ({
    getLeagueMatch: (leagueMatchId) => dispatch(leagueTeamActions.getLeagueMatch(leagueMatchId)),
    updateLeagueMatch: (leagueMatchId, leagueMatch) => dispatch(leagueTeamActions.updateLeagueMatch(leagueMatchId, leagueMatch))
});
export var LeagueMatchContextMode;
(function (LeagueMatchContextMode) {
    LeagueMatchContextMode[LeagueMatchContextMode["ClubMode"] = 0] = "ClubMode";
    LeagueMatchContextMode[LeagueMatchContextMode["AdminMode"] = 1] = "AdminMode";
})(LeagueMatchContextMode || (LeagueMatchContextMode = {}));
;
const { propsGeneric, connect } = new ConnectedComponent().mapToProps(mapStateToProps, mapDispatchToProps);
const styles = (theme) => ({
    tabRoot: {
        flexGrow: 1,
        backgroundColor: theme.palette.background.paper,
    },
    appBar: {
        backgroundColor: '#eee',
        '& a': {
            color: '#aaa',
            textDecoration: 'none'
        }
    },
    loader: {
        width: '100%',
        '& > * + *': {
            marginTop: theme.spacing(2),
        },
    },
    '@global': {
        '.printHide': {
            '@media print': {
                display: 'none'
            }
        },
        '.printOnly': {
            display: 'none',
            '@media print': {
                display: 'block'
            }
        }
    }
});
class IndberetResultatComponent extends Component {
    constructor(props) {
        super(props);
        //handleTabChange = (event: React.ChangeEvent<{}>, newValue: number) => {
        this.handleTabChange = (event, newValue) => {
            const index = Number(event.currentTarget.id.replace(/nav-tab-(\d+)/, '$1'));
            this.setState({
                selectedTabValue: index,
                selectedTabValueHeader: newValue
            });
            const newMatch = Object.assign({}, this.state.match, Object.assign(Object.assign({}, this.state.match), { resultType: index }));
            this.setState({ match: new LeagueMatchAggregateViewModel(Object.assign({}, newMatch)) });
        };
        this.state = {
            match: new LeagueMatchAggregateViewModel({}),
            selectedTabValue: 0,
            selectedTabValueHeader: 0,
            printBlank: false,
            showErrors: false
        };
        this.updateLeagueMatch = this.updateLeagueMatch.bind(this);
        this.handleOnPrint = this.handleOnPrint.bind(this);
        this.handleTabChange = this.handleTabChange.bind(this);
        this.setMatchState = this.setMatchState.bind(this);
        this.setReservePlayersState = this.setReservePlayersState.bind(this);
        this.setIndividualMatchState = this.setIndividualMatchState.bind(this);
    }
    componentDidMount() {
        const leagueMatchId = parseQueryString('matchId') || "366470";
        this.props.getLeagueMatch(Number(leagueMatchId)).then(() => {
            this.setState({
                match: this.props.model,
                selectedTabValue: this.props.model.resultType
            });
        });
    }
    setMatchState(matchProperty) {
        const newMatch = Object.assign({}, this.state.match, {
            match: Object.assign({}, this.state.match.match, Object.assign(Object.assign({}, this.state.match.match), matchProperty))
        });
        this.setState({ match: newMatch });
    }
    setIndividualMatchState(individualMatch) {
        const oldIndividualMatchIndex = this.state.match.combinedTeamMatches.findIndex(match => match.matchIndex === individualMatch.matchIndex);
        const newIndividualMatch = new LeagueIndividualMatchViewModel(Object.assign(Object.assign({}, this.state.match.combinedTeamMatches[oldIndividualMatchIndex]), individualMatch));
        const newMatch = Object.assign({}, this.state.match, {
            combinedTeamMatches: Object.assign([], this.state.match.combinedTeamMatches)
        });
        newMatch.combinedTeamMatches[oldIndividualMatchIndex] = newIndividualMatch;
        this.setState({ match: newMatch });
    }
    setReservePlayersState(reservePlayers) {
        const newMatch = Object.assign({}, this.state.match, {
            substitutes: reservePlayers
        });
        this.setState({ match: newMatch });
    }
    handleOnPrint(printBlank) {
        this.setState({
            printBlank: printBlank
        });
        setTimeout(() => {
            const iframe = document.createElement('iframe');
            iframe.style.display = "none";
            document.body.appendChild(iframe);
            let printableElements = document.getElementById('v2-edit-match-results').innerHTML;
            const head = document.getElementsByTagName('head')[0];
            const html = '<html><head>' + head.innerHTML + '</head><body>' + printableElements + '</body></html>';
            iframe.contentWindow.document.open();
            iframe.contentWindow.document.write(html);
            iframe.contentWindow.document.close();
            console.log(html);
            iframe.contentWindow.print();
            setTimeout(() => {
                document.body.removeChild(iframe);
            }, 500);
        }, 1000);
    }
    updateLeagueMatch() {
        this.props.updateLeagueMatch(this.state.match.match.leagueMatchId, this.state.match).then((response) => {
            console.log(response);
        });
    }
    clubModeTeamIndex() {
        if (!this.props.user || !this.state.match)
            return -1;
        if (userIsMemberOfClub(this.props.user, this.state.match.match.clubId1))
            return 0;
        if (userIsMemberOfClub(this.props.user, this.state.match.match.clubId2))
            return 1;
        return -1;
    }
    render() {
        const { classes } = this.props;
        if (this.props.systemErrors && this.props.systemErrors.length > 0) {
            return React.createElement(ErrorHandler, { systemErrors: this.props.systemErrors, errorTitle404: "Holdkampen findes ikke", errorBody404: "Den angivne holdkamp kunne ikke findes i systemet" });
        }
        else if (this.props.isLoading || !this.state.match || !this.state.match.match) {
            return React.createElement(Loader, { text: "Indl\u00E6ser holdkampen..." });
        }
        else {
            return (React.createElement(Can, { I: "view", a: AbilitySubjects.LeagueMatchResults },
                this.props.errors &&
                    React.createElement(ErrorHandler, { appError: this.props.errors }),
                React.createElement(Box, { displayPrint: "none" },
                    React.createElement(EditMatchResultActionLinks, { match: this.state.match, user: this.props.user, settings: this.state.match.settings, adminMode: this.props.ContextMode === LeagueMatchContextMode.AdminMode, showSaveDraft: this.state.selectedTabValue === 0, onUpdateLeagueMatch: this.props.updateLeagueMatch, onPrint: this.handleOnPrint })),
                (this.state.match.match.withdrawn1 || this.state.match.match.withdrawn2) &&
                    React.createElement(Box, null,
                        this.state.match.match.withdrawn1 &&
                            React.createElement(Alert, { severity: "warning" },
                                this.state.match.match.teamName1,
                                " er trukket fra kampen"),
                        this.state.match.match.withdrawn2 &&
                            React.createElement(Alert, { severity: "warning" },
                                this.state.match.match.teamName2,
                                " er trukket fra kampen")),
                React.createElement(EditMatchResultBasicData, { match: this.state.match }),
                React.createElement(Box, { className: classes.tabRoot },
                    React.createElement(Box, { displayPrint: "none", className: "printHide" },
                        React.createElement(AppBar, { position: "static", className: classes.appBar },
                            React.createElement(Tabs, { variant: "fullWidth", value: this.state.selectedTabValueHeader, onChange: this.handleTabChange },
                                React.createElement(LinkTab, Object.assign({ label: "Alle resultater", href: "#" }, linkTabProps(LeagueMatchReportingType.AllResults))),
                                React.createElement(LinkTab, Object.assign({ label: "Kun samlet resultat for holdkamp", href: "#" }, linkTabProps(LeagueMatchReportingType.CombinedResults))),
                                React.createElement(LinkTab, Object.assign({ label: "Kun holdopstillinger", href: "#" }, linkTabProps(LeagueMatchReportingType.RostersOnly))),
                                (this.props.ContextMode === LeagueMatchContextMode.ClubMode && this.clubModeTeamIndex() === 0) &&
                                    React.createElement(LinkTab, Object.assign({ label: "Kun holdopstilling hjemmehold", href: "#" }, linkTabProps(LeagueMatchReportingType.PlayersHomeOnly))),
                                (this.props.ContextMode === LeagueMatchContextMode.ClubMode && this.clubModeTeamIndex() === 1) &&
                                    React.createElement(LinkTab, Object.assign({ label: "Kun holdopstilling udehold", href: "#" }, linkTabProps(LeagueMatchReportingType.PlayersAwayOnly))),
                                this.state.match.match.liveScoreEnabled &&
                                    React.createElement(LinkTab, Object.assign({ label: "\u00C5ben for Live Score", href: "#" }, linkTabProps(LeagueMatchReportingType.LiveScore)))))),
                    React.createElement(TabPanel, { value: this.state.selectedTabValue, index: LeagueMatchReportingType.AllResults },
                        React.createElement(EditMatchResultMiscSettings, { matchData: this.state.match.match, setMatchState: this.setMatchState, printBlank: this.state.printBlank, errors: this.props.errors, combinedResultsForTeams: true, publishPlayerRosterNow: true, resultsForMatchClosed: true, remarks: true }),
                        React.createElement("br", null),
                        React.createElement(EditMatchResultPlayersSelect, { match: this.state.match, texts: this.props.texts, showEditPoints: true, updateIndividualMatchState: this.setIndividualMatchState, printBlank: this.state.printBlank }),
                        React.createElement("br", null),
                        React.createElement(AddReservePlayers, { match: this.state.match, setReservePlayersState: this.setReservePlayersState })),
                    React.createElement(TabPanel, { value: this.state.selectedTabValue, index: LeagueMatchReportingType.CombinedResults },
                        React.createElement(EditMatchResultMiscSettings, { matchData: this.state.match.match, setMatchState: this.setMatchState, printBlank: this.state.printBlank, errors: this.props.errors, combinedResultsForTeams: true, resultsForMatchClosed: true, remarks: true })),
                    React.createElement(TabPanel, { value: this.state.selectedTabValue, index: LeagueMatchReportingType.RostersOnly },
                        React.createElement(EditMatchResultMiscSettings, { matchData: this.state.match.match, setMatchState: this.setMatchState, printBlank: this.state.printBlank, errors: this.props.errors, publishPlayerRosterNow: true, remarks: true }),
                        React.createElement("br", null),
                        React.createElement(EditMatchResultPlayersSelect, { match: this.state.match, texts: this.props.texts, showEditPoints: false, printBlank: this.state.printBlank }),
                        React.createElement("br", null),
                        React.createElement(AddReservePlayers, { match: this.state.match, setReservePlayersState: this.setReservePlayersState })),
                    (this.props.ContextMode === LeagueMatchContextMode.ClubMode && this.clubModeTeamIndex() === 0) &&
                        React.createElement(TabPanel, { value: this.state.selectedTabValue, index: LeagueMatchReportingType.PlayersHomeOnly },
                            React.createElement(EditMatchResultPlayersSelect, { match: this.state.match, texts: this.props.texts, showEditPoints: true, printBlank: this.state.printBlank, updateIndividualMatchState: this.setIndividualMatchState, disablePlayerEditForTeamIndex: 0 })),
                    (this.props.ContextMode === LeagueMatchContextMode.ClubMode && this.clubModeTeamIndex() === 1) &&
                        React.createElement(TabPanel, { value: this.state.selectedTabValue, index: LeagueMatchReportingType.PlayersAwayOnly },
                            React.createElement(EditMatchResultPlayersSelect, { match: this.state.match, texts: this.props.texts, showEditPoints: true, printBlank: this.state.printBlank, updateIndividualMatchState: this.setIndividualMatchState, disablePlayerEditForTeamIndex: 1 })),
                    this.state.match.match.liveScoreEnabled &&
                        React.createElement(TabPanel, { value: this.state.selectedTabValue, index: LeagueMatchReportingType.LiveScore },
                            React.createElement(EditMatchResultMiscSettings, { matchData: this.state.match.match, setMatchState: this.setMatchState, printBlank: this.state.printBlank, errors: this.props.errors, publishPlayerRosterNow: true, remarks: true, liveScore: true }),
                            React.createElement("br", null),
                            React.createElement(EditMatchResultPlayersSelect, { match: this.state.match, texts: this.props.texts, showEditPoints: false, printBlank: this.state.printBlank }),
                            React.createElement("br", null),
                            React.createElement(AddReservePlayers, { match: this.state.match, setReservePlayersState: this.setReservePlayersState })))));
        }
    }
}
const IndberetResultat = withStyles(styles, { withTheme: true })(connect(IndberetResultatComponent));
export default IndberetResultat;
